<div class="canvas-renderer-container">
<!-- Entity Visualization Canvas -->
<rappider-ai-entity-visualization-canvas
  *ngIf="canvasType === AIGenerationType.ENTITY_COMPONENT"
  [projectModelId]="selectedProjectModelId"
  [componentDefinitionId]="componentDefinitionId">
</rappider-ai-entity-visualization-canvas>

<!-- Data Model Canvas -->
<rappider-ai-generate-data-model-canvas
  *ngIf="canvasType === AIGenerationType.DATA_MODEL"
  [projectModelId]="selectedProjectModelId">
</rappider-ai-generate-data-model-canvas>

<!-- Page Canvas -->
<!-- <rappider-ai-generate-page-canvas
  *ngIf="canvasType === AIGenerationType.PAGE"
  [projectModelId]="selectedProjectModelId"
  (splitterToggleRequested)="onSplitterToggleRequested($event)">
</rappider-ai-generate-page-canvas> -->

<!-- Component Canvas -->
<!-- <rappider-ai-generate-component-canvas
  *ngIf="canvasType === AIGenerationType.COMPONENT"
  [projectModelId]="selectedProjectModelId"
  (splitterToggleRequested)="onSplitterToggleRequested($event)">
</rappider-ai-generate-component-canvas> -->

<!-- Theme Canvas -->
<!-- <rappider-ai-generate-theme-canvas
  *ngIf="canvasType === AIGenerationType.THEME"
  [projectModelId]="selectedProjectModelId"
  (splitterToggleRequested)="onSplitterToggleRequested($event)">
</rappider-ai-generate-theme-canvas> -->

<!-- Workflow Canvas -->
<!-- <rappider-ai-generate-workflow-canvas
  *ngIf="canvasType === AIGenerationType.WORKFLOW"
  [projectModelId]="selectedProjectModelId"
  (splitterToggleRequested)="onSplitterToggleRequested($event)">
</rappider-ai-generate-workflow-canvas> -->
</div>
